export const localText = {
  loginButton: 'Login',
  subtitle: 'Sign in to manage CDH operations',
  title: 'CDH Operations Hub',
}
